webpackJsonp([18585890350193],{

/***/ 360:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"html":"<p>I'm officeless and proud to be so.\nI'll share my experience at <a href=\"https://www.facebook.com/events/1655414721455166/\">Hello Job!.. again!</a>.</p>\n<h2>Slides</h2>\n<iframe src=\"https://docs.google.com/presentation/d/1-FBAGYBqgXI_ULfLdy8bVvKaeuv0YLMgOkXUKtsGWTA/embed?start=false&loop=false&delayms=3000\" frameborder=\"0\" width=\"960\" height=\"749\" allowfullscreen=\"true\" mozallowfullscreen=\"true\" webkitallowfullscreen=\"true\"></iframe>","frontmatter":{"title":"Officeless"}}},"pathContext":{"slug":"officeless/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---officeless-afd36d6609b9a99463f1.js